import { createEmployees } from "../../infrastructure/repository/employees-repository";
import {
  findEmployeesWithFields,
  resetEmployeeCache,
} from "../../infrastructure/employees-cache";
import { findCompanyId } from "../../infrastructure/repository/company-repository";
import { displayUploadEmployeesPage } from "./displays/display-upload-employees-page";
import { addToSelected } from "./select-employees";
import { showErrorMessage } from "../commons/show-error-message";
import { logError, addContextLog } from "../../infrastructure/log";
import { translate as t } from "../../infrastructure/translate/localization";
import adaptEmployeeFromDetailModal from "../../infrastructure/adapters/adaptEmployeeFromDetailModal";
import { showSuccessMessage } from "../commons/show-success-message";
import { showWarningMessage } from "../commons/show-warning-message";

export async function uploadEmployees(employees) {
  if (employees && employees.length > 0) {
    try {
      const companyId = await findCompanyId();

      await createEmployees({
        employees,
        companyId,
      });
      resetEmployeeCache();
      const allEmployees = await findEmployeesWithFields({ companyId });
      const successfullyUploaded = allEmployees.filter(
        (e) => e.state === "uploading" && !e.warning && !e.error
      );

      addToSelected({ ids: successfullyUploaded.map((e) => e.id) });

      addContextLog("info", "uploadEmployees", "request", { companyId });

      displayUploadEmployeesPage();
    } catch (e) {
      logError(e, `Error to uploadEmployees`);
      showErrorMessage(t("common-messages.basic-error-message"), true);
    }
  }
}

export async function uploadEmployeesV2({
  company,
  employees,
  benefitPlanId,
  taxRegime,
}) {
  const resultantEmployees = employees.map((employee) =>
    adaptEmployeeFromDetailModal({ employee, benefitPlanId, taxRegime })
  );
  try {
    const { data: createdEmployees } = await createEmployees({
      employees: resultantEmployees,
      companyId: company.id,
    });
    const employeesWithErrorsCount = createdEmployees.filter(
      (e) => e.error
    ).length;
    const employeesWithWarningsCount = createdEmployees.filter(
      (e) => e.warning
    ).length;
    const employeeUnSuccessfulCount =
      employeesWithWarningsCount + employeesWithErrorsCount;

    if (createdEmployees.length === employeesWithErrorsCount) {
      showErrorMessage(t("common-messages.basic-error-message"), true);
    } else if (employeeUnSuccessfulCount > 0) {
      showWarningMessage(
        t(
          `upload-employees-section.uploaded-employees-with-errors-or-warnings${
            resultantEmployees.length !== 1 ? "-plural" : ""
          }-message`,
          {
            name: resultantEmployees[0].name,
          }
        )
      );
    } else {
      showSuccessMessage(
        t(
          `benefits-section.successfully-created${
            resultantEmployees.length !== 1 ? "-plural" : ""
          }-message`,
          {
            name: resultantEmployees[0].name,
          }
        )
      );
    }
  } catch (e) {
    showErrorMessage(t("common-messages.basic-error-message"), true);
  }
}
